import { create } from 'zustand'

/**
 * Whose video you have chosen not to see — the participant menu's "Mute video".
 *
 * That item was a button with no handler: it did nothing on any device. It now
 * hides one person's camera on THIS screen only. Their tile shows their
 * initials, and their stream is dropped from the set lastN keeps flowing, so
 * the video is not downloaded either. Nothing is sent to the room and they are
 * not told; it is not moderation (moderators have Stop video for that).
 *
 * Same lifetime as the personal volume mix beside it, and for the same reason:
 * the key is an SFU `peerId`, issued per join, so it is not persisted and is
 * dropped on leave.
 */
type ParticipantVideoHiddenState = {
  /** peerId -> true while hidden. Absent means shown. */
  hidden: Record<string, true>
  toggle: (peerId: string) => void
  /** Show everyone again. Called on leave so the next meeting starts clean. */
  reset: () => void
}

export const useParticipantVideoHiddenStore = create<ParticipantVideoHiddenState>()((set) => ({
  hidden: {},
  toggle: (peerId) =>
    set((prev) => {
      const next = { ...prev.hidden }
      if (next[peerId]) delete next[peerId]
      else next[peerId] = true
      return { hidden: next }
    }),
  reset: () => set({ hidden: {} }),
}))
